import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShipments, setVehicles, setOutput, clearAll, setErrors } from '../redux/globalSlice';
import { validateShipments, validateVehicles } from '../utils/validatorHelpers';
import generateJson from '../utils/generateJsonHelper';
import FileUploadSection from '../components/FileUploadSection';

const FileUploadSectionContainer = () => {
  const dispatch = useDispatch();
  const { vehicles, shipments } = useSelector((state) => state.global);

  const handleShipmentsFileChange = (shipmentsData) => {
    const validationResults = validateShipments(shipmentsData);

    if (validationResults.length > 0) {
      dispatch(setErrors(validationResults));
    } else {
      dispatch(setShipments(shipmentsData));
    }
  };

  const handleVehiclesFileChange = (vehiclesData) => {
    const validationResults = validateVehicles(vehiclesData);

    if (validationResults.length > 0) {
      dispatch(setErrors(validationResults));
    } else {
      dispatch(setVehicles(vehiclesData));
    }
  };

  const handleClearAll = () => {
    dispatch(clearAll());
  };

  const handleGenerateJson = () => {
    dispatch(setOutput(generateJson(vehicles, shipments)));
  };

  return (
    <div>
      <FileUploadSection
        onShipmentsFileChange={handleShipmentsFileChange}
        onVehiclesFileChange={handleVehiclesFileChange}
        onGenerateJson={handleGenerateJson}
        onClearAll={handleClearAll}
        onSetErrors={(errors) => dispatch(setErrors(errors))}
        totalShipments={shipments.length}
        totalVehicles={vehicles.length}
      />
    </div>
  );
};

export default FileUploadSectionContainer;
